// extracted by mini-css-extract-plugin
module.exports = {"errorBox":"errorBox___3RlIt","errorText":"errorText___2g-nb"};